import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { SectionSwapModel } from '../models/course_section_swap_model';
import { ClearSwapToSectionsCommand } from './clear_swap_to_sections_command';

export type ClearSwapSelectionsCommand = () => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .service(
    'clearSwapSelectionsCommand',
    function clearSwapSelectionsCommandDefinition(
      defineCommandORM: IDefineCommand,
      clearSwapToSectionsCommand: ClearSwapToSectionsCommand,
      ngCourseSectionSwapModel: SectionSwapModel
    ) {
      return defineCommandORM('clearSwapSelectionsCommand', function clearSwapSelectionsCommand(deferred) {
        clearSwapToSectionsCommand().then(() => {
          ngCourseSectionSwapModel.clear();
          deferred.resolve();
        });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/swap/commands/clear_swap_selections_command.ts